import React from 'react'
import { connect } from 'react-redux'
import InstructorsCoursesList from './InstructorsCoursesList'

class InstructorsCoursesCompleted extends React.Component {
  handleStartCourse = courseId => {
    this.props.endCourse(courseId)
  }

  render() {
    const buttonActions = []
    return (
      <InstructorsCoursesList
        {...this.props}
        buttonActions={buttonActions}
        titleLabel="Istoric cursuri"
        labelDialogTitle="Sunteti sigur?"
        labelDialogCancel="Anuleaza"
        labelDialogConfirm="Confirma"
        handleAction={this.handleStartCourse}
      />
    )
  }
}

export default connect(null, {})(InstructorsCoursesCompleted)



// WEBPACK FOOTER //
// ./src/instructors/InstructorsCoursesCompleted.js